<template>
	<span>
		<div @click="navigatoToCertificate"
			class="col-md-9 margin-left-14">
			<a v-if="certificate.typeAlert === 'certificate-received'"> Consulta {{ getName(this.certificate.certificateName) }} do cliente {{ this.certificate.name }} esta pronta  <i class="fa fa-check text-success"></i> </a>
			<a v-if="certificate.typeAlert === 'certificate-creation-failed'"> Houve um erro ao consultar a cerdidão {{ getName(this.certificate.certificateName) }} para o cliente. Por favor tente novamente {{ this.certificate.name }} <i class="fa fa-check text-success"></i> </a>
			<br>
		</div>
		<div class="col-md-1" @click="close">
			<i class="fa fa-window-close icon"></i> 
		</div>
		<div class="space-50"></div>
		<small class="pull-right">{{ this.certificate.date | time }}</small>
	</span>
</template>

<script>
export default {
  name: 'CertificateReadyNotification',
  props: {
    certificate: {
      type: Object,
      required: true
    }
  },
  methods: {
    navigatoToCertificate () {
      if (this.$route.name === 'clients_add') {
        this.$router.push({name: 'clients_add', params: {clientId: this.certificate.id}, query: {showCertificate: true}})
      } else {
        this.$router.push({name: 'clients_details', params: {clientId: this.certificate.id}, query: {showCertificate: true}})
      }
      this.$emit('decreaseNotification', this.certificate)
    },
    getName (type) {
      let data = this.getCertificateTypes()
      return data[type]
    },
    close () {
      this.$emit('decreaseNotification', this.certificate)
    }
  }
}
</script>

<style scoped>
	.card:hover {
	background: #f5f8fa;
	border-radius: 8px;
	}

	.card {
	padding: 10px;
	cursor: pointer;
	}

	a {
	color: #777777;
	}

	.icon {
	color: #189ce2;
	border-color: #168ccb;
	font-size: 1.8rem;
	}
</style>


// WEBPACK FOOTER //
// CertificateReadyNotification.vue?60c46532